import { useEffect, useState } from 'react'
import { UseFormSetValue } from 'react-hook-form'

export function useEventPricing(setValue: UseFormSetValue<any>, defaultValue: number, defaultIncrement: number) {
    const [pricingFields, setPricingFields] = useState<number[]>([defaultValue])
    const [increment, setIncrement] = useState<number>(defaultIncrement)

    const addPricingFieldHigher = () => {
        setPricingFields((prev) => {
            const highestValue = Math.max(...prev)
            return [highestValue + increment, ...prev]
        })
    }

    const addPricingFieldLower = () => {
        setPricingFields((prev) => {
            const lowestValue = Math.min(...prev)
            const newValue = lowestValue - increment
            return [...prev, newValue < 100 ? 100 : newValue]
        })
    }

    const removePricingField = (index: number) => {
        setPricingFields((prev) => {
            if (prev.length > 1) {
                return prev.filter((_, i) => i !== index)
            }
            return prev
        })
    }

    const handleIncrementValueChange = (value: number) => {
        setValue('increment', value)
        setIncrement(value)
    }

    const handlePriceChange = (index: number, newPrice: number) => {
        setPricingFields((prev) => prev.map((price, i) => (i === index ? newPrice : price)))
        setValue(`price_${index}`, newPrice)
    }

    useEffect(() => {
        pricingFields.forEach((price, index) => {
            setValue(`price_${index}`, price)
        })
    }, [pricingFields, setValue])

    return {
        pricingFields,
        increment,
        addPricingFieldHigher,
        addPricingFieldLower,
        removePricingField,
        handleIncrementValueChange,
        handlePriceChange,
    }
}
